<template>
  <section id="show-entity-request-modal">
    <!-- Details Modal -->
    <va-modal
      :value="isOpen"
      ref="entityRequestModal"
      :showOkay="entityRequest.status == 0 && (userIsFromEntity(1) || userIsFromEntity(2))"
      :okText="$t('modals.buttons.create')"
      :cancelText="$t('modals.buttons.cancel')"
      :cancelDisabled="isLoading"
      :okDisabled="isLoading"
      @cancel="closeModal"
      @ok="createEntity"
    >

      <div slot="header" class="modal-title">
        <span>{{$t('entityrequests.request')}}</span>
      </div>

      <LoadingPlaceholder v-if="isLoading"/>

      <div v-else>

      <div class="modal-header-actions d-flex justify-content-end">
        <va-popover
          placement="left"
          :message="$t('buttons.update')"
          v-if="userProfile && entityRequest.status == 0 && (userIsFromEntity(1) || userIsFromEntity(2))">
          <va-button
            large
            class="va-button-rounded"
            icon="fa fa-pencil"
            color="gray"
            @click="updateEntityRequest">
          </va-button>
        </va-popover>
      </div>

      <div class="row" style="margin-top: -15px;">
        <div class="col-md-6">
          <div class="d-flex align-items-center mb-4">
            <h3 class="mb-0">{{entityRequest.entity_name}}</h3>
            <va-popover v-if="entityRequest.entity !== null" :options="{content: $t('entityrequests.redirect_to_entity'), placement: 'top'}" class="clickable">
              <i class="pt-2 fa fa-external-link custom-icon px-2" @click="redirectToEntity(entityRequest.entity.id)"></i>
            </va-popover>
          </div>
          <div><label class="is-bold mb-0">{{ $t('entityrequests.inputs.entity_nif') }}:</label> {{entityRequest.entity_nif}}</div>
          <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.facility_code')}}:</label> {{entityRequest.facility_code}}</div>
          <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.entity_phone')}}:</label> {{entityRequest.entity_phone}}</div>
          <br>
          <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.responsible_name')}}:</label><br>{{entityRequest.responsible_name}}</div>
          <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.responsible_email')}}:</label><br>{{entityRequest.responsible_email}}</div>
          <br>
          <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.contact_name')}}:</label><br>{{entityRequest.contact_name}}</div>
          <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.contact_email')}}:</label><br>{{entityRequest.contact_email}}</div>
          <br>
        </div>
        <div class="col-md-6">
          <br>
          <div><label class="is-bold mb-0">{{$t('entityrequests.request_created_by')}}:</label> {{entityRequest.created_by ? entityRequest.created_by.name : ''}}</div>
          <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.status')}}:</label>
            <span v-if="entityRequest.status == 0"> {{$t('entityrequests.status.pending')}}&nbsp;<i class="fa fa-clock-o"></i></span>
            <span v-else> {{$t('entityrequests.status.created')}}&nbsp;<i class="fa fa-check" style="color: #29c4a9;"></i></span>
          </div>
          <br>
          <div v-if="entityRequest.senior_manager"><label class="is-bold mb-0">{{$t('entityrequests.senior_manager')}}:</label> {{entityRequest.senior_manager.name}}<br></div>
          <div v-if="entityRequest.manager"><label class="is-bold mb-0">{{$t('entityrequests.manager')}}:</label> {{entityRequest.manager.name}}<br></div>
          <div v-if="entityRequest.consultant"><label class="is-bold mb-0">{{$t('entityrequests.consultant')}}:</label> {{entityRequest.consultant.name}}<br></div>

          <span v-if="entityRequest.address_line_1 || entityRequest.address_line_2 || entityRequest.address_city || entityRequest.address_postal_code">
            <br>
            <label class="is-bold mb-0">{{ $t('leads.details.address') }}:</label><br>
            {{entityRequest.address_line_1}}<span v-if="entityRequest.address_line_1 && (entityRequest.address_line_2 || entityRequest.address_city || entityRequest.address_postal_code)">,<br></span>
            {{entityRequest.address_line_2}}<span v-if="entityRequest.address_line_2 && (entityRequest.address_city || entityRequest.address_postal_code)">,<br></span>
            {{entityRequest.address_city}}<span v-if="entityRequest.address_city && entityRequest.address_postal_code">,<br></span>
            {{entityRequest.address_postal_code}}
          </span>

        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
        <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.kiosk_interest')}}:</label> {{entityRequest.kiosk_interest ? $t('entityrequests.yes') : $t('entityrequests.no')}}<br></div>
        <div><label class="is-bold mb-0">{{$t('entityrequests.kiosk_pricing')}}:</label> {{entityRequest.kiosk_pricing ? $t('entityrequests.sent') + moment(this.entityRequest.kiosk_pricing, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY') :  $t('entityrequests.not_sent')}}<br></div>
        <div><label class="is-bold mb-0">{{$t('entityrequests.portable_pricing')}}:</label>  {{entityRequest.portable_pricing ? $t('entityrequests.sent') + moment(this.entityRequest.portable_pricing, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY') :  $t('entityrequests.not_sent')}}<br></div>
        <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.business_plan')}}:</label>  {{entityRequest.business_plan_id !== null ? getBusinessPlanById(entityRequest.business_plan_id).name : $t('entityrequests.undefined')}}<br></div>
        <div><label class="is-bold mb-0">{{$t('entityrequests.preferred_week_day')}}:</label>  {{entityRequest.preferred_week_day !== null ? $t(getWeekDayById(entityRequest.preferred_week_day).name) : $t('entityrequests.undefined')}}<br></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <br>
          <div><label class="is-bold mb-0">{{$t('entityrequests.previous_aud_provider_experience')}}</label><br>{{entityRequest.previous_aud_provider !== null ? entityRequest.previous_aud_provider : $t('entityrequests.undefined') }}</div>
        </div>
      </div>
      <div class="row" v-if="entityRequest.observations">
        <div class="col-md-12">
          <br>
         <div><label class="is-bold mb-0">{{$t('entityrequests.inputs.observations')}}:</label><br>{{entityRequest.observations}}</div>
        </div>
      </div>
      </div>
    </va-modal>

    <CreateOrUpdateEntityRequestModal
      v-if="isUpdatingEntityRequest"
      :entityRequest="entityRequest"
      :weekDays="weekDays"
      :userProfile="userProfile"
      :businessPlans="businessPlans"
      @entity-request-updated="onEntityRequestUpdated"
      @cancel="onCloseUpdateEntityRequestModal"
      @deleteEntityRequest="onDeleteEntityRequest"
    >
    </CreateOrUpdateEntityRequestModal>

  </section>

</template>

<script>
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin'
import { HollowDotsSpinner } from 'epic-spinners'
import CreateOrUpdateEntityRequestModal from '@/components/entityrequests/CreateOrUpdateEntityRequestModal'
import { EntityRequestService } from '@/api/LeadsService'
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder'
export default {
  props: {
    entityRequest: {
      type: Object,
      required: true
    },
    businessPlans: {
      type: Array,
      required: false
    },
    weekDays: {
      type: Array,
      required: false
    },
    userProfile: {
      type: Object,
      required: true
    }
  },
  components: {
    LoadingPlaceholder,
    CreateOrUpdateEntityRequestModal,
    EntityRequestService,
    HollowDotsSpinner
  },
  mixins: [
    IsFromEvolluMixin
  ],
  data: function () {
    return {
      isOpen: false,
      isUpdatingEntityRequest: false,
      isDeletingEntityRequest: false,
      isLoading: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    redirectToEntity: function (entityId) {
      this.$refs.entityRequestModal.cancel()
      setTimeout(() => { this.$router.push({ name: 'adminentities/id', params: { id: entityId } }) }, 500)
    },
    closeModal: function () {
      setTimeout(() => this.$emit('cancel'), 500)
    },
    createEntity: function () {
      this.isLoading = true
      EntityRequestService.confirmEntityRequest(this.entityRequest.id)
        .then(response => {
          this.isLoading = false
          this.$emit('entityCreated')
          this.isOpen = false
          this.showToast(this.$t('entities.entity_created'), this.$store.state.successToastOptions)
        })
        .catch(errors => {
          this.showToast(this.$t('clusters.messages.something_went_wrong'), this.$store.state.errorToastOptions)
          this.isLoading = false
        })
    },
    getBusinessPlanById: function (id) {
      return this.businessPlans.find(businessPlan => businessPlan.id === id)
    },
    getWeekDayById: function (id) {
      return this.weekDays.find(weekDay => weekDay.value === id)
    },
    updateEntityRequest: function () {
      this.isOpen = false
      setTimeout(() => { this.isUpdatingEntityRequest = true }, 500)
    },
    onDeleteEntityRequest: function (entityRequest) {
      this.$emit('deleteEntityRequest', entityRequest)
      this.isOpen = false
      this.isUpdatingEntityRequest = false
      this.isDeletingEntityRequest = true
    },
    onCloseUpdateEntityRequestModal: function () {
      this.isOpen = true
      this.isUpdatingEntityRequest = false
    },
    onEntityRequestUpdated: function (payload) {
      this.$emit('entity-request-updated', payload)
    }
  }
}
</script>
